import {MultiSelectFilter} from './multi-select.filter';
import {AdminUserFilter} from './admin-user.filter';
import {CertifiedSuperUserFilter} from "./certified-super-user.filter";

export var filtersModule = angular.module('authentication.filters', [])
    .filter('multiSelectFilter', MultiSelectFilter)
    .filter('adminUserFilter', AdminUserFilter)
    .filter('certifiedSuperUserFilter', CertifiedSuperUserFilter)
;
